/* eslint-disable */
import axios from 'axios';
import { getToken, setToken, removeToken } from '../store/auth';

let ENV = 'ocupacional'; // ⬅️ Altere para: 'matriz', 'ocupacional', 'localhost', 'isas'

let baseURL = '';
let ativarFuncaoMatriz = false;
let ativarFuncaoOcupacional = false;
let base = '';

switch (ENV) {
  case 'matriz':
    baseURL = 'https://smv2.simplesmedic.com.br/api/';
    base = 'https://smv2.simplesmedic.com.br/';
    ativarFuncaoMatriz = true;
    break;
  case 'ocupacional':
    baseURL = 'https://smv2.cmremedios.com.br/api/';
    base = 'https://smv2.cmremedios.com.br/';
    ativarFuncaoOcupacional = true;
    break;
  case 'localhost':
    baseURL = 'http://localhost:3005/'
     // baseURL = 'http://localhost:3005/';
    base = 'http://localhost:3005/';
    break;
  case 'isas':
    baseURL = 'http://10.0.0.100:3000/';
    base = 'http://10.0.0.100:3000/';
    break;
  default:
    throw new Error('Ambiente não reconhecido');
}
console.log(`Ambiente: ${ENV}, Base URL: ${baseURL}, ${base}`);

export { baseURL, base, ENV };

export const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'x-access-token': getToken()
  }
});

export const apiBot = axios.create({
  baseURL: 'https://simplesmedic.herokuapp.com/',
  headers: {
    'Content-Type': 'application/json',
    'x-access-token': getToken()
  }
});

export const relatorioService = axios.create({
  baseURL: ENV === 'localhost'
    ? '/'
    : 'https://smv2reports.simplesmedic.com.br/'
});

export const apiWifi = axios.create({
  baseURL: 'http://10.0.0.69:3000/'
});

export const apiVoucher = axios.create({
  baseURL: 'https://smi.simplesmedic.com.br/',
  headers: {
    'Content-Type': 'application/json',
    'token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NiwidXNlcm5hbWUiOiJmaWxhQXBpIiwiaWF0IjoxNjg1NDY5NjMwfQ.LRcn9izlCPirHKXlxprr-vIn0qDb4wMaCuKXXyFNS0Q'
  }
});

// Ativar API IA conforme ambiente
export const apiIA = axios.create({
  baseURL: ENV === 'localhost'
    ? '/api-ia'
    : ativarFuncaoMatriz
      ? 'https://apidrmed.simplesmedic.com.br'
      : 'https://apipp.drmedpro.com.br/',
  headers: {
    'Content-Type': 'application/json',
    'Authorization':
      'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmaWxhc212MiJ9.tnqUOJM5UtsuQ4oMd5jvzt5lLT610EUf56dWIecwDDE'
  }
});
